import { useState } from "react";
import { deleteProduct } from "../../../../common/services/product.api";

type Props = {
    productId: string;
    onDeleted: (productId: string) => void;
    onCancel: () => void;
};

export default function FormDeleteProduct({ productId, onDeleted, onCancel }: Props) {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    async function handleConfirm() {
        try {
            setLoading(true);
            setError(null);
            const resp = await deleteProduct(productId);
            if (!resp.ok) {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                throw new Error((resp as any)?.message || "Falha ao deletar produto");
            }
            onDeleted(productId);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e: any) {
            setError(e?.message || "Falha ao deletar produto");
        } finally {
            setLoading(false);
        }
    }

    return (
        <div className="space-y-4">
            <p>Tem certeza que deseja deletar o produto?</p>

            {error && <div className="text-red-600 text-sm">{error}</div>}

            <div className="flex gap-3 justify-end">
               
                <button
                    onClick={onCancel}
                    className="px-4 py-2 rounded-lg bg-gray-200"
                >
                    Voltar
                </button>

                <button
                    onClick={handleConfirm}
                    disabled={loading}
                    className="px-4 py-2 rounded-lg bg-red-600 text-white disabled:opacity-50"
                >
                    {loading ? "Deletando..." : "Deletar"}
                </button>
            </div>
        </div>
    );
}
